import { FilterModel } from '@helios/filter-modal'
import { PositionsRequestContext } from '../services/positions.service'

export interface Position {
  acctId: number
  accountName: string
  secId: number
  units: number
  posTypeCode: PositionType
  secIdentifier: string
  cwanIdentifier?: string
  secCusip?: string
  secIsin?: string
  secFigi?: string
  secSedol?: string
  secTypeCode: string
  description: string
  matchStatus: MatchStatus
  matchDate: string
  unitDifference: number
  extPosSourceType?: ExternalDataSourceType
  extPosSource: string
  positionId: string
  cwanUnits: number
  cwanOriginalUnits?: number
  externalUnits: number
  status?: 'INCORRECT' | 'NO_ERROR'
  extOriginId?: number
  currencyCode: string
  normModelId?: number
  extPosId?: number
  inventoryType?: string
  collateralBroker?: string
  isExternalToExternalModeSelected?: boolean
}

export interface PositionsSetValues {
  acctId: number[]
  secId: number[]
  posTypeCode: PositionType[]
  secTypeCode: string[]
  matchStatus: MatchStatus[]
  extPosSourceType: ExternalDataSourceType[]
  extPosSource: string[]
  currencyCode: string[]
  acctName: string[]
  inventoryType: InventoryType[]
  collateralBroker: string[]
}
export enum PositionTypeEnum {
  MARGIN = 'Margin',
  POSITION = 'Position',
  CASH = 'Cash',
}

export interface ExportExcelRequest {
  fields: string[]
  headers: string[]
  filters: FilterModel
  context: PositionsRequestContext
  userTimeZone: string
}

export interface PositionAvailableRestrictedColumns {
  column: string
  isAvailable: boolean
}

export interface PositionsActionPermissions {
  canTransferOutAllPositionsOneSided: boolean
  canTransferOutAllPositionsDirect: boolean
  canFilterTransactionByAssetId: boolean
  canFilterTransactionByCurrency: boolean
  canExchange: boolean
  canTransferPosition: boolean
  canCreateSecurityMapping: boolean
}

export type ExternalDataSourceType = 'Custody' | 'Trading' | 'Unknown'
export type PositionType = 'Cash' | 'Position' | 'Margin'
export type MatchStatus = 'CW_ONLY' | 'EXTERNAL_ONLY' | 'MATCHED'
export type InventoryType = 'LONG' | 'SHORT' | 'ISSUE'
